




























import { Component, Vue } from 'vue-property-decorator';

import { routes } from '@/router';
import { sessionStore } from '@/store/session';

import toast from '../toast';
import { ToastType } from '../toast/tost-type.enum';

@Component({
  components: {},
})
export default class Sidebar extends Vue {
  private collapsed = false;

  public toggleSidebar() {
    this.collapsed = !this.collapsed;
  }

  private logout() {
    sessionStore.clear();
    this.$router.replace({
      name: 'login',
    });
    toast('Até a próxima!', ToastType.SUCESS);
  }

  get userImage() {
    return sessionStore.session?.user?.image;
  }

  get userName() {
    return sessionStore.session?.user?.name;
  }

  get userEmail() {
    return sessionStore.session?.user?.email;
  }

  get routes() {
    const finalRoutes = routes.filter(({ meta }) => meta.menu !== false);
    const homeRouteIndex = finalRoutes.findIndex(({ name }) => name === 'home');
    if (homeRouteIndex === -1) {
      return finalRoutes;
    }

    const homeRoute = finalRoutes.splice(homeRouteIndex, 1)[0];
    return [homeRoute].concat(finalRoutes);
  }
}
